export const validateTestMaterialInfosConfig = [
  {
    name: 'customerName',
    text: '企業・団体名',
  },
  {
    name: 'customerAddress',
    text: '所在地',
  },
  {
    name: 'phone1',
    text: 'TEL',
  },
  {
    name: 'department',
    text: '部署名',
  },
  {
    name: 'picNameKanji',
    text: '氏名',
  },
  {
    name: 'billingAddress',
    text: '請求先',
    value: 'その他|',
  },
  {
    name: 'concentraction',
    text: '試験濃度',
    required_if: 'classification',
    required_value: 'leanOff',
  },
  {
    name: 'dilutionMedia',
    text: '希釈媒体',
    required_if: 'classification',
    required_value: 'leanOff',
  },
  {
    name: 'ingrediants',
    text: '成分名・配合量',
    required_if: 'volatileComponents',
    required_value: '含む',
  },
  {
    name: 'cosmeticType',
    text: 'シート状（厚さ）',
    value: 'シート状（厚さ）|',
  },
  {
    name: 'cosmeticType',
    text: 'その他の詳細',
    value: 'その他|',
  },
  {
    name: 'cosmeticUsage',
    text: 'メイク品',
    value: 'メイク品|',
  },
  {
    name: 'cosmeticUsage',
    text: 'その他の詳細',
    value: 'その他|',
  },
  {
    name: 'dilutionMedia',
    text: 'その他の詳細',
    value: 'その他|',
  },
  {
    name: 'storageClassification',
    text: 'その他の詳細',
    value: 'その他|',
  },
];